<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="活动详情"
        v-loading="loading"
    >
        <div class="container">
            <div class="formCont">
                <el-row>
                    <el-col :span="12">
                        <div class="label">活动名称：</div>
                        <div class="content">{{ msg.title }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">活动地点：</div>
                        <div class="content">{{ msg.address }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">联系人：</div>
                        <div class="content">{{ msg.contact_name }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">联系电话：</div>
                        <div class="content">{{ msg.contact_phone }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">活动开始时间：</div>
                        <div class="content">{{ msg.start_time }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">活动结束时间：</div>
                        <div class="content">{{ msg.end_time }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">活动封面：</div>
                        <div class="content">
                                <!-- src="http://oa-sit.loratech.cn/upload/images/20210602/v45ngU3U28eUaw0uWN23.png" -->
                            <el-image
                                :src="msg.cover"
                                fit="fill"
                                :preview-src-list="previewList"
                            ></el-image>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">主办方：</div>
                        <div class="content">{{ msg.sponsor }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="[showReview ? 12 : 24]">
                        <div class="label">活动内容：</div>
                        <div class="content">{{ msg.content }}</div>
                    </el-col>
                    <el-col :span="12" v-if="showReview">
                        <div class="label">回顾内容：</div>
                        <div class="content">{{ msg.reviewContent }}</div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- <div class="container">
            <el-form
                ref="editForm"
                :rules="rules"
                :model="editForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="活动名称 :"
                            size="small"
                            prop="title"
                        >
                            <div class="content">{{ msg.title }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="活动地点 :"
                            size="small"
                            prop="address"
                        >
                            <div class="content">{{ msg.address }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="联系人 :"
                            size="small"
                            prop="contact_name"
                        >
                            <div class="content">
                                {{ msg.contact_name }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="联系电话 :"
                            size="small"
                            prop="contact_phone"
                        >
                            <div class="content">
                                {{ msg.contact_phone }}
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="活动开始时间 :"
                            size="small"
                            prop="start_time"
                        >
                            <div class="content">{{ msg.start_time }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="活动结束时间 :"
                            size="small"
                            prop="end_time"
                        >
                            <div class="content">{{ msg.end_time }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="活动封面 :"
                            size="small"
                            prop="cover"
                        >
                            <div class="content">
                                <el-image
                                    :src="msg.cover"
                                    fit="fill"
                                    :preview-src-list="previewList"
                                ></el-image>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="主办方 :"
                            size="small"
                            prop="sponsor"
                        >
                            <div class="content">{{ msg.sponsor }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="活动内容 :"
                            size="small"
                            prop="content"
                        >
                            <div class="content">{{ msg.content }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div> -->
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                @click="detailVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
export default {
    name: "eventsRecordDetail",
    data() {
        return {
            loading: false,
            msg: {},
            previewList: [],
            showReview:false
        };
    },
    watch: {
        detailVisible: {
            handler(newValue) {
                if (newValue) {
                    this.activityList();
                }
            },
        },
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
    },
    methods: {
        closeDialog() {
            this.$emit("update:detailVisible", false);
        },
        activityList() {
            oaApi.activityList({}, "get", this.tableItem.id).then((res) => {
                if (res.code == 200) {
                    this.msg = res.data;
                    this.previewList = this.msg.cover.split(",");
                    if (this.tableItem.status == 10  || this.tableItem.status == 20) {
                        oaApi
                            .eventsReview(
                                {
                                    event_id: this.tableItem.id,
                                },
                                "get"
                            )
                            .then((res) => {
                                if (res.code == 200) {
                                    //console.log(res);
                                    this.$set(this.msg,"reviewContent",res.data.review);
                                    this.showReview = true;
                                }else{
                                    this.showReview = false;
                                }
                            });
                    }
                }
            });
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>

</style>